const SS_MENU_SCROLL_PREFIX = "rms_menu_scroll_v1:";
const SS_MENU_SCROLL_TTL_MS = 30 * 60 * 1000;

function toStr(v) {
  return String(v ?? "").trim();
}

export function readMenuScrollRestore(restaurantId) {
  if (!restaurantId) return null;
  try {
    const raw = sessionStorage.getItem(SS_MENU_SCROLL_PREFIX + restaurantId);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.categoryId || Date.now() - (parsed.savedAt || 0) > SS_MENU_SCROLL_TTL_MS) {
      sessionStorage.removeItem(SS_MENU_SCROLL_PREFIX + restaurantId);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveMenuScrollRestore(restaurantId, { categoryId, scrollTop, menuItemId }) {
  if (!restaurantId || !categoryId) return;
  try {
    sessionStorage.setItem(
      SS_MENU_SCROLL_PREFIX + restaurantId,
      JSON.stringify({
        categoryId: toStr(categoryId),
        menuItemId: menuItemId ? toStr(menuItemId) : "",
        scrollTop: Number(scrollTop) || 0,
        savedAt: Date.now(),
      })
    );
  } catch {}
}

export function clearMenuScrollRestore(restaurantId) {
  if (!restaurantId) return;
  try {
    sessionStorage.removeItem(SS_MENU_SCROLL_PREFIX + restaurantId);
  } catch {}
}

export function hasMenuScrollRestore(restaurantId) {
  return Boolean(readMenuScrollRestore(restaurantId));
}

export function getRestaurantIdFromMenuPath(pathname) {
  const m = String(pathname || "").match(/^\/restaurant\/([^/]+)$/);
  return m?.[1] ? toStr(m[1]) : "";
}
